import { useEffect, useState } from 'react';
const LOCAL_STORAGE_KEY = 'hasDownloadInstructionsBeenShownForCourse';
const getModalTrackerObject = () => {
  const modalTrackerObjectRaw = localStorage.getItem(LOCAL_STORAGE_KEY);
  try {
    return JSON.parse(modalTrackerObjectRaw !== null && modalTrackerObjectRaw !== void 0 ? modalTrackerObjectRaw : '');
  } catch (_unused) {
    localStorage.setItem(LOCAL_STORAGE_KEY, '{}');
  }
  return {};
};
const hasDownloadInstructionsModalBeenShown = courseId => {
  const courseDownloadInstructionsTracker = getModalTrackerObject();
  return courseDownloadInstructionsTracker[courseId] !== true;
};
const setDownloadInstructionsModalShownForCourse = (courseId, value) => {
  const courseDownloadInstructionsTracker = getModalTrackerObject();
  courseDownloadInstructionsTracker[courseId] = value;
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(courseDownloadInstructionsTracker));
};
export const useDownloadInstructionsModalSmartOpen = courseId => {
  const [showDownloadInstructions, setShowDownloadInstructions] = useState(false);
  useEffect(() => {
    if (courseId && hasDownloadInstructionsModalBeenShown(courseId)) {
      setShowDownloadInstructions(true);
      setDownloadInstructionsModalShownForCourse(courseId, true);
    }
  }, [courseId]);
  const openDownloadInstructions = () => {
    setShowDownloadInstructions(true);
  };
  const closeDownloadInstructions = () => {
    setShowDownloadInstructions(false);
  };
  return {
    closeDownloadInstructions,
    openDownloadInstructions,
    showDownloadInstructions
  };
};